import React, { useMemo, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import { FiMoreVertical } from "react-icons/fi";
import ScreenOption from "../ScreenOption";
import { FiFilter } from "react-icons/fi";
import { dashboardLinkList } from "app/_pages/Constants";
import { Link } from "react-router-dom";
import FilesExport from "app/Components/CommanComponents/FilesExport";
import { useSelector } from "react-redux";

const DashboardNav = ({
  screenCount,
  onFilterBool,
  pageBool,
  page,
  dashboardName,
  id,
}) => {
  const [showFilter, setShowFilter] = useState(false);

  const pageChange = ({ target: { value } }) => {
    pageBool(value);
  };
  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  const screenMemoArray = useMemo(() => {
    let optionsList = [];
    for (let i = 1; i <= screenCount; i++) {
      optionsList.push({ screen: i, name: `screen${i}` });
    }
    console.log(optionsList);
    return optionsList;
  }, [screenCount, globalSelectedSiteId]);

  const rightFilterFun = () => {
    setShowFilter(!showFilter);
    onFilterBool(!showFilter);
  };

  return (
    <Row>
      <Col lg={12}>
        <div className="dashboardNav">
          <Row>
            <Col lg={8}>
              <Col lg={5} className="m-0 p-0">
                <Dropdown>
                  <DropdownToggle variant="link" className="toggle-hidden p-0">
                    <h3 class="font-weight-bold m-0 pr-3">
                      <span className="mr-2">{dashboardName}</span>
                      <span>
                        <FiMoreVertical />
                      </span>
                    </h3>
                  </DropdownToggle>
                  <DropdownMenu>
                    {Object.entries(dashboardLinkList)?.map((item) => (
                      <Link key={item[0]} to={`/${item[0]}/dashboard`}>
                        <span className="dropdown-item cursor-pointer">{item[1]}</span>
                      </Link>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Col>

            <Col lg={4}>
              <div className="d-flex justify-content-end">
                <ScreenOption
                  pageList={screenMemoArray}
                  onChangeScreen={pageChange}
                  pageValue={page}
                />
                {id && <FilesExport id={`#${id}`} fullScreen />}
                <div
                  onClick={rightFilterFun}
                  className="handle d-flex p-8 mr-0"
                  style={{
                    background: "#292075",
                    cursor: "pointer",
                    borderRadius: "4px",
                    margin: " 0 14px",
                    boxShadow: "-3px 0px 4px rgb(0 0 0 / 6%)",
                    color: "#fff",
                    fontSize: "17px",
                  }}
                >
                  <FiFilter />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default DashboardNav;
